module.exports = __webpack_public_path__ + "static/media/example-1.d911d243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Koombana/example-1.jpg
// module id = 298
// module chunks = 0